import {button,escapeHtml,message} from '../ui/components.js';

function catalogueName(item){
  return String(item?.displayName||item?.displayNames?.pl||item?.display_name_pl||item?.key||'').trim();
}

function inventoryName(item,catalogue=[]){
  const custom=String(item?.customName||item?.custom_name||'').trim();
  if(custom)return custom;
  const key=String(item?.catalogueKey||item?.wood_key||'').trim();
  const found=(catalogue||[]).find(entry=>String(entry?.key||'')===key);
  return catalogueName(found)||key;
}

function sourceOptions(catalogue=[],inventory=[],selected=''){
  const available=(inventory||[])
    .filter(item=>item&&!item.archivedAt&&item.available!==false)
    .map(item=>({
      value:'inventory:'+String(item.id||''),
      label:'Moja wędzarnia: '+inventoryName(item,catalogue)
    }))
    .filter(item=>item.value!=='inventory:'&&item.label!=='Moja wędzarnia: ');

  const global=(catalogue||[])
    .filter(item=>item&&item.active!==false)
    .map(item=>({
      value:'catalogue:'+String(item.key||''),
      label:'Katalog: '+catalogueName(item)
    }))
    .filter(item=>item.value!=='catalogue:'&&item.label!=='Katalog: ');

  return [...available,...global].map(item=>
    '<option value="'+escapeHtml(item.value)+'"'+(item.value===selected?' selected':'')+'>'+
    escapeHtml(item.label)+'</option>'
  ).join('');
}

function selectedSource(item){
  if(item?.sourceKind==='inventory')return 'inventory:'+String(item.inventoryItemId||'');
  if(item?.sourceKind==='catalogue')return 'catalogue:'+String(item.woodKey||'');
  return '';
}

function mixNotice(summary){
  if(summary.status==='optional')return '';
  if(summary.status==='complete')return message({text:'Udziały drewna sumują się do 100%.',kind:'success'});
  if(summary.status==='partial')return message({
    text:'Podano część udziałów ('+summary.totalPercent+'%). Pozostałe mogą pozostać bez procentu.',
    kind:'info'
  });
  return message({
    text:summary.totalPercent>100
      ?'Suma podanych udziałów przekracza 100%.'
      :'Jeśli podajesz udział dla każdego drewna, suma powinna wynosić 100%.',
    kind:'warning'
  });
}

function row(item,index,total,editable){
  const meta=item.sharePercent==null?'Udział opcjonalny':String(item.sharePercent)+'%';
  const controls=editable
    ?'<div class="actions compact">'+
      button({label:'Edytuj',variant:'secondary',attributes:{'data-journal-wood-edit':item.id}})+
      button({label:'↑',variant:'ghost',disabled:index===0,attributes:{'data-journal-wood-up':item.id}})+
      button({label:'↓',variant:'ghost',disabled:index===total-1,attributes:{'data-journal-wood-down':item.id}})+
      button({label:'Usuń',variant:'danger',attributes:{'data-journal-wood-remove':item.id}})+
      '</div>'
    :'';
  return '<article class="panel journal-wood-row"><div><strong>'+escapeHtml(item.nameSnapshot)+
    '</strong><p>'+escapeHtml(meta)+'</p></div>'+controls+'</article>';
}

export function sessionWoodEditorMarkup({
  items=[],
  catalogue=[],
  inventory=[],
  editingItem=null,
  shareSummary={status:'optional',totalPercent:0},
  offline=false,
  sessionStatus='draft'
}={}){
  const editable=['draft','planned','preparation','ready'].includes(String(sessionStatus||'').toLowerCase());
  const list=(items||[]).length
    ?items.map((item,index)=>row(item,index,items.length,editable)).join('')
    :'<p class="panel-copy">Dodaj drewno planowane do tej sesji.</p>';

  const lock=editable?'':message({
    text:'Mieszanka drewna jest zablokowana po rozpoczęciu właściwego procesu wędzenia.',
    kind:'warning'
  });
  const offlineNotice=offline?message({
    text:'Pracujesz offline. Zmiany zostaną zapisane lokalnie i oczekują na synchronizację.',
    kind:'warning'
  }):'';

  const form=editable
    ?'<form id="session-wood-form" class="smoker-form" novalidate>'+offlineNotice+
      '<div class="smoker-form-section"><h2>'+(editingItem?'Edytuj drewno':'Dodaj drewno')+'</h2>'+
      '<div class="form-grid">'+
      '<label class="field"><span class="field-label">Źródło drewna</span><select name="woodSource" required>'+
      '<option value="">Wybierz…</option>'+sourceOptions(catalogue,inventory,selectedSource(editingItem))+'</select></label>'+
      '<label class="field"><span class="field-label">Udział % (opcjonalnie)</span>'+
      '<input name="sharePercent" type="number" min="0.01" max="100" step="0.01" value="'+
      escapeHtml(editingItem?.sharePercent??'')+'"></label></div></div>'+
      '<div class="actions">'+button({label:editingItem?'Zapisz zmiany':'Dodaj drewno',type:'submit'})+
      (editingItem?button({id:'cancel-session-wood-edit',label:'Anuluj',variant:'ghost'}):'')+
      '</div></form>'
    :'';

  return '<section class="journal-wood-editor">'+lock+mixNotice(shareSummary)+
    '<div class="journal-wood-list">'+list+'</div>'+form+'</section>';
}
